import { PlainText } from '../list/commonCells'
import { monthYear, shortDay } from '../record/format'
import type { Agreement } from './types'

/** The next deadline of an agreement; a late one in the error colour with "te laat" in words. */
export function NextDeadline({ agreement }: { agreement: Agreement }) {
  const due = agreement.open_deadline?.due_on ?? agreement.next_due_on
  if (!due) return <span className="text-muted-foreground">—</span>
  if (agreement.badge === 'achterstallig' && agreement.overdue_days) {
    return (
      <span className="font-semibold text-destructive">
        ! {shortDay(due)} · {agreement.overdue_days === 1 ? '1 dag' : `${agreement.overdue_days} dagen`} te laat
      </span>
    )
  }
  return <span>{shortDay(due)}</span>
}

export function Duration({ agreement }: { agreement: Agreement }) {
  const start = monthYear(agreement.starts_on)
  return <PlainText value={agreement.ends_on ? `${start} – ${shortDay(agreement.ends_on)}` : `Vanaf ${start}`} />
}
